export type DataWedgeApiModuleEvents = {
  onIntentReceived: (params: { intent: Intent }) => void;

  onCommandResult: (param: { intent: null | Intent }) => void;
};

export type Intent = {
  action: null | string;
  categories: null | string[];
  data: null | string;
  extras: null | Record<string, any>;
};

export type CommandArg =
  | {
      type: "int";
      value: number;
    }
  | {
      type: "string";
      value: string;
    }
  | {
      type: "bundle";
      value: Record<string, CommandArg>;
    }
  | {
      type: "string_array";
      value: string[];
    }
  | {
      type: "parcelable_array" | "parcelable_arraylist";
      value: Record<string, CommandArg>[];
    };

export type SetConfigParams = {
  profileName: string;
  configMode?: "CREATE_IF_NOT_EXIST" | "OVERWRITE" | "UPDATE";
  profileEnabled?: boolean;
  appList: {
    packageName: string;
    activityList: string[];
  }[];
  pluginConfig?: (
    | {
        name: "KEYSTROKE";
        resetConfig?: boolean;
        paramList: {
          outputEnabled?: boolean;
          // ...
        };
      }
    | {
        name: "INTENT";
        resetConfig?: boolean;
        paramList: {
          outputEnabled?: boolean;
          intentAction?: string;
          intentCategory?: string;
          intentDelivery?: "start_activity" | "start_service" | "broadcast";
          // ...
        };
      }
  )[];
};

export type SetConfigResult = {
  RESULT:
    | "SUCCESS"
    | "PLUGIN_NOT_SUPPORTED"
    | "BUNDLE_EMPTY"
    | "PROFILE_NAME_EMPTY"
    | "PROFILE_NOT_FOUND"
    | "PLUGIN_BUNDLE_INVALID"
    | "PARAMETER_INVALID"
    | "APP_ALREADY_ASSOCIATED"
    | "OPERATION_NOT_ALLOWED"
    | "RESULT_ACTION_RESULT_CODE_EMPTY_RULE_NAME"
    | "UNLICENSED_FEATURE";
  RESULT_INFO?: any;
};

type IntentPluginConfig = {
  PLUGIN_NAME: "INTENT";
  PARAM_LIST: {
    intent_output_enabled: "true" | "false";
    intent_action: string;
    intent_category: string;
    intent_component_info: unknown;
    intent_delivery: string;
    intent_use_content_provider: "true" | "false";
    intent_flag_receiver_foreground: "true" | "false";
    intent_start_foreground_service_on_failure: "true" | "false";
    // ...
  };
};

export function isIntentPlugin(
  plugin: PluginConfig
): plugin is IntentPluginConfig {
  return plugin.PLUGIN_NAME === "INTENT";
}

type KeystrokePluginConfig = {
  PLUGIN_NAME: "KEYSTROKE";
  PARAM_LIST: {
    keystroke_output_enabled: "true" | "false";
    // ...
  };
};

export function isKeystrokePlugin(
  plugin: PluginConfig
): plugin is KeystrokePluginConfig {
  return plugin.PLUGIN_NAME === "KEYSTROKE";
}

type PluginConfig =
  | IntentPluginConfig
  | KeystrokePluginConfig
  | {
      PLUGIN_NAME?: Exclude<string, "KEYSTROKE" | "INTENT" | "IP">;
      PARAM_LIST?: unknown;
    };

export type GetConfigResult = {
  PROFILE_ENABLED: "true" | "false";
  PROFILE_NAME: string;
  PLUGIN_CONFIG: PluginConfig[];
  APP_LIST: {
    ACTIVITY_LIST: string[];
    PACKAGE_NAME: string;
  }[];
};

export type NotificationType = keyof Notifications;

export type Notifications = {
  PROFILE_SWITCH: {
    PROFILE_ENABLED?: boolean;
    PROFILE_NAME?: null | string;
  };
  SCANNER_STATUS: {
    STATUS?:
      | null
      | "WAITING"
      | "SCANNING"
      | "CONNECTED"
      | "DISCONNECTED"
      | "IDLE"
      | "DISABLED";
    PROFILE_NAME?: null | string;
  };
};
